import fetch from '../../../actions/fetch';
import { ERROR_DEBUG_MESSAGES } from '../constants/paymentErrors';

const CHANGE_PAYMENT_ENDPOINT = '/billingsubscriptions/subscription/billdate/change';

const THREE_DS_REQUIRED_STATUS_CODE = 422;

const getPaymentAuthorizationToken = errorResponseBody =>
  errorResponseBody?.status === THREE_DS_REQUIRED_STATUS_CODE
    ? errorResponseBody?.data?.[0]?.paymentAuthorizationRequestToken ||
      errorResponseBody?.errorResponse?.PaymentAuthorizationRequestToken
    : null;
const changeBillDateMethod =
  ({ selectedBillDate, paymentMethodToken, paymentAuthorizationResult }) =>
  async dispatch => {
    const requestBody = {
      method: 'PUT',
      body: {
        paymentMethodToken,
        selectedBillDate,
        ...(paymentAuthorizationResult ? { paymentAuthorizationResult } : {}),
      },
    };

    try {
      const changeResult = await dispatch(fetch(CHANGE_PAYMENT_ENDPOINT, requestBody));

      return {
        complete: true,
        error: null,
        threeDSecureActionTokenId: null,
        data: changeResult?.data?.[0] ?? null,
      };
    } catch (paymentErrorResponse) {
      const errorResponseBody =
        paymentErrorResponse?.json && typeof paymentErrorResponse.json === 'function'
          ? await paymentErrorResponse.json().catch(() => ({}))
          : {};

      const paymentAuthorizationToken = getPaymentAuthorizationToken({
        ...errorResponseBody,
        status: paymentErrorResponse?.status,
      });

      if (paymentAuthorizationToken) {
        return {
          complete: false,
          error: null,
          threeDSecureActionTokenId: paymentAuthorizationToken,
        };
      }

      return {
        complete: false,
        error: ERROR_DEBUG_MESSAGES.PAYMENT.NON_3DS_ERROR,
        threeDSecureActionTokenId: null,
      };
    }
  };

export default changeBillDateMethod;
